/**
 * @generated SignedSource<<114748e97f3e3ca33f2e0c71f5aa38a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreviousBookingsStep_TimeSlot$data = {
  readonly capacity: number;
  readonly usedCapacity: number;
  readonly " $fragmentType": "PreviousBookingsStep_TimeSlot";
};
export type PreviousBookingsStep_TimeSlot$key = {
  readonly " $data"?: PreviousBookingsStep_TimeSlot$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreviousBookingsStep_TimeSlot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "bookingType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreviousBookingsStep_TimeSlot",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "bookingType",
          "variableName": "bookingType"
        }
      ],
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usedCapacity",
      "storageKey": null
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};

(node as any).hash = "aa9157bb635f28969bd750982ddbb2a7";

export default node;
